import PropTypes from 'prop-types'
import styled from 'styled-components'
import { forwardRef } from 'react'

import { flexItemPropTypes, flexItemMixin } from '../utils'
import { getMargin, getPadding, marginPropTypes, paddingPropTypes } from '../../utils'

const StyledBox = styled.div`
  box-sizing: border-box;
  display: ${({ display }) => (display === 'inline' ? 'inline-block' : 'block')};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  min-width: ${({ minWidth }) => minWidth};
  min-height: ${({ minHeight }) => minHeight};
  ${({ alignSelf }) =>
    typeof alignSelf !== 'undefined' ? `align-self: ${alignSelf}` : null};
  ${flexItemMixin};
  ${getMargin};
  ${getPadding};
`
const Box = forwardRef(function Box(
  {
    children,
    alignSelf,
    display = 'block',
    width = 'auto',
    height = 'auto',
    minWidth = 'auto',
    minHeight = 'auto',
    ...rest
  },
  ref
) {
  return (
    <StyledBox
      ref={ref}
      alignSelf={alignSelf}
      display={display}
      width={width}
      height={height}
      minWidth={minWidth}
      minHeight={minHeight}
      {...rest}>
      {children}
    </StyledBox>
  )
})

Box.propTypes = {
  ...marginPropTypes,
  ...paddingPropTypes,
  ...flexItemPropTypes,
  alignSelf: PropTypes.string,
  display: PropTypes.oneOf(['block', 'inline']),
  width: PropTypes.string,
  height: PropTypes.string,
  minWidth: PropTypes.string,
  minHeight: PropTypes.string
}

export { Box }
